// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__25EZ-","header":"ReportDetails_header__144pa","title":"ReportDetails_title__1mHDO","left":"ReportDetails_left__6-1rW"};